import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'h3-button',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ButtonComponent {
  @Input({ required: true }) type!: string;
  @Input() extraClasses = '';
  @Input() tabIndex?: string;
  @Input() h3Tooltip?: string;
  @Input() blockStyle = false;

  /**
   * It would be nice to use `(click)`, but it's not a good idea to match native
   * dom event names. https://github.com/angular/angular/issues/4059
   */
  @Output() h3Click = new EventEmitter();

  /**
   * if this is a string, it will be shown as a tooltip
   */
  @Input() disable?: boolean | string = false;

  /**
   * Use this or `(h3Click)`. With this option, the button will spin until the
   * returned promise resolves.
   */
  @Input() clickCallback?: () => Promise<any> | void;

  onClickNSpin = () => {
    this.h3Click.emit();
    if (this.clickCallback) {
      return this.clickCallback();
    }
  };
}
